import { Text, Icon } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router';
import { SindiButton } from '@/components/button/SindiButton';

interface NavItemProps {
  to: string;
  icon?: React.ElementType;
  children: React.ReactNode;
  isActive?: boolean;
  onClick?: () => void;
}

function NavItem({ to, icon, children, isActive, onClick }: NavItemProps) {
  return (
    <RouterLink to={to} style={{ display: 'block', width: '100%' }}>
      <SindiButton
        variant="ghost"
        w="full"
        justifyContent="flex-start"
        bg={isActive ? 'gray.700' : 'transparent'}
        color="white"
        _hover={{
          bg: 'gray.700',
        }}
        onClick={onClick}
      >
        {icon && <Icon as={icon} mr={3} boxSize={5} />}
        <Text fontWeight={isActive ? 'semibold' : 'medium'}>{children}</Text>
      </SindiButton>
    </RouterLink>
  );
}

export default NavItem;
